// extracted by mini-css-extract-plugin
module.exports = {"formSection":"styles_formSection__27i62","automaticJobApplicationApproval":"styles_automaticJobApplicationApproval__1mqpv"};